import { useQuery } from '@tanstack/react-query'
import jsCookies from 'js-cookie'

import { BonhamsCookies, EBonhamsCookies } from '@nx/global-types'
import { getJWTExpiryFromCookieClient } from '@nx/helpers'

import { getUsersWonLots } from './getUsersWonLots'

interface UseGetUsersWonLotsProps {
  baseURL: string
}

export function useGetUsersWonLots({ baseURL }: UseGetUsersWonLotsProps) {
  const refreshToken = jsCookies.get(EBonhamsCookies.refresh)
  const tokenExpirationDateInSeconds = getJWTExpiryFromCookieClient(
    EBonhamsCookies.access
  )

  return useQuery({
    queryKey: ['usersWonLots'],
    queryFn: () => {
      const accessToken = jsCookies.get(EBonhamsCookies.access)
      const refreshToken = jsCookies.get(EBonhamsCookies.refresh)

      return getUsersWonLots({
        baseURL,
        cookies: {
          bonhams_access: accessToken,
          bonhams_token: refreshToken,
        } as BonhamsCookies,
      })
    },
    enabled: !!refreshToken,
    staleTime:
      tokenExpirationDateInSeconds > 0
        ? Math.abs(tokenExpirationDateInSeconds * 1000 - Date.now())
        : 0,
  })
}
